import { ActionIcon, Button, Modal, Select, Tooltip } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconLock } from "@tabler/icons-react";
import { useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  ZNS_TEMPLATE_IDS,
  createZnsPayload,
  sendZnsMessage,
} from "../../../../service/znsService";

const CloseOrderButton = ({ row, fetchData }: { row: any; fetchData: any }) => {
  const [opened, setOpened] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const reasons = [
    { value: "T1", label: "T1 Bom hàng / Trả hàng hủy cọc" },
    { value: "T2", label: "T2 Thao tác nhầm(xử lý tại chỗ)" },
    { value: "T6", label: "T6 KH đổi ý(xử lý tại chỗ)" },
  ];

  const handleCancelDelivery = async (orderNumber: string) => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDelivery/cancel-deliveries",
      {
        type: "HUY_DON",
        SourceCode: orderNumber,
      },
      true,
    );
    if (res && res?.success) {
      NotificationExtension.Success("Hoàn tất hủy đơn hàng !");
      setTimeout(() => {
        modals.closeAll();
      }, 1000);
    }
  };

  const handleSendZnsCancelOrder = async (orderNumber: string) => {
    try {
      // Lấy chi tiết đơn hàng để có đủ thông tin gửi ZNS
      const orderDetail = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/CreateSellItem/details?orderNumber=${orderNumber}`,
      );

      if (!orderDetail?.success) return;

      const orderHeader = orderDetail.data?.orderHeader;

      // Lấy thông tin khách hàng
      const customerRes = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmCustomer/get-detail?id=${orderHeader?.custId}`,
      );
      const customer = customerRes?.data;

      // Lọc: không gửi cho khách doanh nghiệp, nhóm 166, khách CAM
      if (customer?.groupId === 166) return;
      if (customer?.type !== 1) return;
      if (
        customer?.groupCode === "PHUQUYHY_CAM" ||
        customer?.groupCode === "CAM"
      )
        return;

      // Thử lấy branchId và dvtn từ nhiều trường hợp có thể của orderHeader hoặc row
      const branchIdToCheck = orderHeader?.orgId || orderHeader?.branchId || row?.original?.orgId || row?.original?.branchId || row?.branchId;
      const dvtnToCheck = orderHeader?.dvtn || row?.original?.dvtn || row?.dvtn;

      // Kiểm tra xem đơn hàng có thuộc chi nhánh DVT hay không
      const listBranchRes = await repositoryPos.get<MessageResponse<any>>("/api/v1/TblDmInventory/get-select-branch");
      const isDVT = 
        dvtnToCheck === "DVT" || 
        listBranchRes?.data?.find(
          (item: any) => Number(item.value) === Number(branchIdToCheck)
        )?.attr6 === "DVT";

      console.log("[DVT-DEBUG] CloseOrderButton handleSendZnsCancelOrder - isDVT:", isDVT, "| dvtnToCheck:", dvtnToCheck, "| branchIdToCheck:", branchIdToCheck);
      if (isDVT) return;

      // Lấy số điện thoại từ attribute1 hoặc customer
      let customerData: any = null;
      try {
        customerData = orderHeader?.attribute1
          ? JSON.parse(orderHeader.attribute1)
          : null;
      } catch (_) {}

      const recipientPhone =
        customerData?.telephoneNumber || customer?.telephoneNumber;
      if (!recipientPhone) return;

      // Format ngày mua
      const formatDate = (value?: string | Date | null) => {
        if (!value) return "";
        const date = new Date(value);
        return Number.isNaN(date.getTime())
          ? ""
          : date.toLocaleDateString("vi-VN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            });
      };

      const znsResponse = await sendZnsMessage(
        createZnsPayload(
          `${orderNumber}-CLOSE-${Date.now()}`,
          ZNS_TEMPLATE_IDS.ORDER_CANCELLED,
          {
            customer_name:
              customer?.name ||
              customerData?.customerName ||
              "Khách hàng",
            ma_don_hang: orderNumber,
            ngay_mua_hang: formatDate(orderHeader?.orderDate),
          },
          recipientPhone,
        ),
      );

      if (znsResponse?.status === 0 || znsResponse?.success === false) {
        console.warn(
          "Gửi ZNS đóng đơn thất bại:",
          znsResponse?.description || znsResponse?.message,
        );
      }
    } catch (znsError) {
      console.error("Lỗi khi gửi ZNS thông báo đóng đơn:", znsError);
    }
  };

  const handleCloseOrder = async () => {
    if (!selectedReason) {
      alert("Vui lòng chọn lý do đóng đơn!");
      return;
    }

    const url = `/api/v1/CreateSellItem/close?id=${row.id}&reason=${selectedReason}`;

    try {
      const response = await repositoryPos.get(url);

      if (response && response.success) {
        NotificationExtension.Success("Đóng đơn thành công!");

        // Gửi ZNS thông báo đóng đơn (không await để không block UI)
        const orderNumber = row?.original?.orderNumber || row?.orderNumber;
        if (orderNumber) {
          handleSendZnsCancelOrder(orderNumber);
        }

        handleCancelDelivery(row?.original?.orderNumber);
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        NotificationExtension.Fails("Đóng đơn thất bại!");
      }
    } catch (error) {
      NotificationExtension.Fails("Có lỗi xảy ra khi đóng đơn!");
    }

    setOpened(false);
  };

  return (
    <>
      {/* Nút mở popup */}
      <Tooltip label="Đóng đơn">
        <ActionIcon
          variant="light"
          aria-label="Đóng đơn"
          color="red"
          onClick={() => setOpened(true)}
        >
          <IconLock size={20} />
        </ActionIcon>
      </Tooltip>

      {/* Popup chọn lý do */}
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Chọn lý do đóng đơn"
        centered
      >
        <Select
          mt={15}
          data={reasons}
          placeholder="Chọn lý do"
          value={selectedReason}
          onChange={(value) => {
            setSelectedReason(value || "");
          }}
          searchable
        />
        <Button
          fullWidth
          mt="md"
          color="red"
          onClick={handleCloseOrder}
          disabled={!selectedReason}
        >
          Xác nhận đóng đơn
        </Button>
      </Modal>
    </>
  );
};

export default CloseOrderButton;
